import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const settingsServiceName = "EmergencyCenter-Service: ";
const EMERGENCY_CENTER_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/emergencycenter';

export default class EmergencyCenterService {

    static async readAllEmergencyCentersPaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['name'], ['name']);
        await WrapperService.get(EMERGENCY_CENTER_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveEmergencyCenter(emergencyCenter, successF, errorF) {
        if (typeof emergencyCenter.id === 'undefined' || emergencyCenter.id === null) {
            await WrapperService.post(EMERGENCY_CENTER_API_URL, emergencyCenter, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(EMERGENCY_CENTER_API_URL + '/' + emergencyCenter.id, emergencyCenter, settingsServiceName, successF, errorF);
        }
    }
}